import { FC, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useProductTableQuery } from "../hooks/useProductTableQuery";
import { useProductCatalogContext } from "../../ProductCatalogContext";
import { useGetVendorProductColumns } from "./hooks/useGetVendorProductColumns";
import { Skeleton } from "../../../../components/loading";
import { OutlinedPaper } from "../../../../components/OutlinedPaper";

interface VendorProductsTableProps {
  vendorId: number;
  vendorName: string;
  isLoading: boolean;
}
export const VendorProductsTable: FC<VendorProductsTableProps> = (props) => {
  const { entityTypeFilterValue, localizeInstalls } =
    useProductCatalogContext();

  const { results, loading } = useProductTableQuery(
    props.vendorId,
    localizeInstalls,
    entityTypeFilterValue
  );

  const { columns } = useGetVendorProductColumns();

  const rows = useMemo(() => {
    return results.map((product) => {
      return {
        id: product.productId,
        productName: product.productName,
        numberOfCompanies: product.companyCount,
      };
    });
  }, [results]);

  return (
    <OutlinedPaper>
      <Stack gap={1} p={2} id="products-table">
        <Box display="flex" gap={1}>
          <Typography variant="h1">Products of</Typography>
          <Skeleton isLoading={props.isLoading} width={180} height={40}>
            <Typography variant="h1">{props.vendorName}</Typography>
          </Skeleton>
        </Box>
        <Skeleton isLoading={loading} height={400} margin="10px 0 0 0">
          <DataGrid
            data-testid="catalog-vendor-products-table"
            rows={rows}
            columns={columns}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "numberOfCompanies",
                    sort: "desc",
                  },
                ],
              },
            }}
            sortingOrder={["desc", "asc"]}
            hideFooter
            disableColumnMenu
            disableColumnResize
            disableRowSelectionOnClick
            sx={{
              border: "none",
              "& .MuiDataGrid-iconSeparator": {
                display: "none",
              },
            }}
          />
        </Skeleton>
      </Stack>
    </OutlinedPaper>
  );
};
